export default __webpack_public_path__ + "68455bf0b026911df9d62b458e72315f.svg";